import React from 'react';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import CategoriaDeCurriculo from 'Interface/CategoriasDeCurriculo';
import { useRemoverCategoriaDeCurriculoMutation } from 'View/Service/Default/CategoriasDeCurriculo';

interface Props {
  dados: CategoriaDeCurriculo;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerCategoria] = useRemoverCategoriaDeCurriculoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerCategoria({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div
      key={dados.nome}
      className="d-flex border-bottom align-items-center py-2 px-3"
    >
      <div className="fs-4">
        <Link
          to={`/categorias-de-curriculo/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.nome}
        </Link>
      </div>
      <div className="ms-5 fs-5 flex-grow-1 text-end">
        <Botao
          icone="trash"
          tema="danger"
          className="ms-5"
          confirmacao="Você tem certeza que deseja remover essa categoria? Essa ação é irreversivel."
          onClick={remover}
        />
      </div>
    </div>
  );
};

export default Lista;
